import Axios from 'axios'
import config from '../config'

export const ON_DEMAND_APIS = {
  /* No Param */
  AREA_OF_INTERESTS: `${config.apiUrl}/api/v1/area_of_interests`,
  GET_ABSTRACT: (abstractId) => `${config.apiUrl}/api/v1/abstracts/${abstractId}`,

  /**
   * Params:
   * page=number (if blank, gets all abstracts)
   * page_length=number (default to 20)
   * area_of_interest=string
   */
  POSTERS: `${config.apiUrl}/api/v1/poster`,
  ORALS: `${config.apiUrl}/api/v1/oral`,

  /**
   * body payload
   * rating: number
   */
  RATE_ABSTRACT: (abstractId) => `${config.apiUrl}/api/v1/abstracts/${abstractId}/abstract_ratings`,
}

export const get = (url: string, successCallback, errorCallback, params = {}) => {
  Axios.get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
    },
    params,
  })
    .then((result) => {
      successCallback(result.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export const post = (url: string, successCallback, errorCallback, data = {}) => {
  Axios.post(
    url,
    {
      data,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    }
  )
    .then((result) => {
      successCallback(result.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
